module.exports = __webpack_public_path__ + "img/bullet.cc7dfc9a.svg";